import { Text } from "components/Typography/text.styled";
import { useTranslation } from "react-i18next";
import {
  DividerLine1,
  FirstContainer,
  FuturePastSalaryContainer,
  FuturePastSalaryListItem,
  SecondContainer,
  ThirdContainer,
} from "./salary.styled";
import { FontFamily, FontSize } from "config/font";
import { Color } from "config/colors";
import { useCallback } from "react";
import { Employment } from "model/OrganizationalStructure";

interface RowProps {
  futureSalary: Employment;
  pastSalary: Employment;
}

export const FuturePastSalaryRow: React.FC<RowProps> = (props) => {
  const { t } = useTranslation();

  const renderRow = useCallback(
    (salary: Employment, index: number, totalLength: number) => {
      const isLastRow = index === totalLength - 1;
      const currency = "kr";

      if (!salary) {
        return (
          <Text
            style={{ margin: 0, padding: 0 }}
            fontSize={FontSize.Small}
            color={Color.SeaBlue600}
          >
            {t("Salary.NoSalary")}
          </Text>
        );
      }

      return (
        <FuturePastSalaryListItem
          lastRow={isLastRow}
          key={`pastSalary-${salary.startDate}`}
        >
          <FirstContainer>
            <Text
              style={{ margin: 0, padding: 0 }}
              fontSize={FontSize.Small}
              color={Color.SeaBlue600}
            >
              {t("Salary.Date")}
            </Text>
            <Text
              color={Color.MidnightBlue}
              fontFamily={FontFamily.MontserratRegular}
            >
              {salary.startDate.split("T")[0]}
            </Text>
          </FirstContainer>
          <DividerLine1 />
          <SecondContainer>
            <Text
              style={{ margin: 0, padding: 0 }}
              fontSize={FontSize.Small}
              color={Color.SeaBlue600}
            >
              {t("Salary.Salary")}
            </Text>
            <Text
              color={Color.MidnightBlue}
              fontFamily={FontFamily.MontserratRegular}
            >
              {`${salary.salary}${currency}`}
            </Text>
          </SecondContainer>
          <ThirdContainer>
            <Text
              style={{ margin: 0, padding: 0 }}
              fontSize={FontSize.Small}
              color={Color.SeaBlue600}
            >
              {t("Salary.WorkPercentage")}
            </Text>
            <Text
              color={Color.MidnightBlue}
              fontFamily={FontFamily.MontserratRegular}
            >
              {`${salary.workPercentage * 100}%`}
            </Text>
          </ThirdContainer>
        </FuturePastSalaryListItem>
      );
    },
    []
  );

  return (
    <FuturePastSalaryContainer>
      {props.futureSalary && (
        <>
          <Text fontFamily={FontFamily.MontserratSemiBold}>
            {t("Salary.FutureSalary")}
          </Text>
          {renderRow(props.futureSalary, 0, 1)}
        </>
      )}
      {props.pastSalary && (
        <>
          <Text
            fontFamily={FontFamily.MontserratSemiBold}
            style={{ marginTop: 20 }}
          >
            {t("Salary.PastSalaries")}
          </Text>
          {renderRow(props.pastSalary, 0, 1)}
        </>
      )}
    </FuturePastSalaryContainer>
  );
};
